<mat-form-field fxFlex="100">
  <mat-label>{{ label }}</mat-label>

  <mat-select
    [value]="value"
    [disabled]="disabled"
    [required]="required"
    [placeholder]="placeholder"
    [compareWith]="compareByPlaceId"
    (selectionChange)="changeValue($event.value)"
    (keydown)="$event.stopPropagation()"
  >
    <mat-select-trigger>
      {{ getSelectedLabel() }}
    </mat-select-trigger>

    <mat-option disabled class="google-place-search-option">
      <div
        class="google-place-search-option__inner"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        (keyup)="$event.stopPropagation()"
        (keypress)="$event.stopPropagation()"
      >
        <ngx-mat-select-search
          [formControl]="searchControl"
          placeholderLabel="Wyszukaj w Google..."
          noEntriesFoundLabel="Brak wyników"
          [searching]="loading"
          [clearSearchInput]="false">
        </ngx-mat-select-search>
      </div>
    </mat-option>

    <mat-option [value]="null">
      Brak
    </mat-option>

    <mat-option
      *ngIf="!loading && (!searchControl.value || searchControl.value.trim().length < 2)"
      disabled>
      Wpisz min. 2 znaki
    </mat-option>

    <mat-option *ngIf="loading" disabled>
      Szukam…
    </mat-option>

    <mat-option
      *ngFor="let item of items"
      [value]="item.place_id"
    >
      <div class="google-place-option">
        <div class="google-place-option__main">
          {{ item.main_text }}
        </div>

        <div class="google-place-option__meta">
          {{ item.secondary_text }}
        </div>
      </div>
    </mat-option>
  </mat-select>
</mat-form-field>
